import { render, staticRenderFns } from "./EditarContrato.vue?vue&type=template&id=c4bd0db8"
import script from "./EditarContrato.vue?vue&type=script&lang=ts"
export * from "./EditarContrato.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports